<div class="language-selector" (clickOutside)="closeDropdown()">
  <button class="language-selector__toggle" (click)="toggleDropdown($event)">
    <ng-container *ngIf="(currentLanguage$ | async) === 'en'">
      <img src="/assets/images/flags/uk.svg" alt="English" class="language-selector__flag" />
      <span class="language-selector__text">EN</span>
    </ng-container>
    <ng-container *ngIf="(currentLanguage$ | async) === 'de'">
      <img src="/assets/images/flags/de.svg" alt="Deutsch" class="language-selector__flag" />
      <span class="language-selector__text">DE</span>
    </ng-container>
    <span class="language-selector__caret"></span>
  </button>
  <div class="language-selector__dropdown" *ngIf="isDropdownOpen">
    <button class="language-selector__option" (click)="setLanguage('en')" [class.active]="(currentLanguage$ | async) === 'en'">
      <img src="/assets/images/flags/uk.svg" alt="English" class="language-selector__flag" />
      <span>English</span>
    </button>
    <button class="language-selector__option" (click)="setLanguage('de')" [class.active]="(currentLanguage$ | async) === 'de'">
      <img src="/assets/images/flags/de.svg" alt="Deutsch" class="language-selector__flag" />
      <span>Deutsch</span>
    </button>
  </div>
  <div class="language-selector__feedback" *ngIf="showFeedback">
    {{ feedbackMessage }}
  </div>
</div>
